import { ReactNode, createContext, useContext } from 'react';
import { useMakeAuth as runAuthorisation } from '@climatepartner/hooks';
import { Spinner } from '@climatepartner/components';

type AuthInfo = ReturnType<typeof authorise>;
type Props = { children: ReactNode };

const defautlAuthInfo = [{ isAuthenticated: false, user: null }, {}] as AuthInfo;

const AuthContext = createContext<AuthInfo>(defautlAuthInfo);

export const AuthProvider = ({ children }: Props) => {
    const auth = authorise();
    const [{ isAuthenticated, user }] = auth;

    if (!isAuthenticated || !user) {
        return <Spinner />;
    }

    return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const context = useContext(AuthContext);

    if (context === undefined) {
        throw new Error('useAuth must be used within a AuthProvider');
    }
    return context;
};

const authorise = () => {
    const { client_id: clientId, issuer } = window.$cp.oidc;

    const oidcConfig = {
        openidRealmConfig: {
            [clientId]: {
                url: `${issuer}/.well-known/openid-configuration`,
                clientId,
            },
        },
        defaultRealm: clientId,
    };
    return runAuthorisation(oidcConfig);
};
